import { useEffect } from 'react';
import { usePageContext } from 'vike-react/usePageContext';
import { setUser, withSentry } from '../utils/sentry/sentry-lazy';

/** Replay sampling needs the live SDK, so it (and its own SDK imports) load only once Sentry has. */
function applyReplaySampling(hasBackofficeAccess: boolean): void {
  withSentry(() => {
    void import('../utils/sentry/sentry-replay-sampling').then((m) =>
      m.applySentryReplaySamplingForSessionUser(hasBackofficeAccess),
    );
  });
}

/**
 * Hook to automatically set Sentry user context based on session
 */
export function useSentryUser() {
  const pageContext = usePageContext();
  const user = (pageContext as any)?.user;
  const hasBackofficeAccess = Boolean((pageContext as any)?.hasBackofficeAccess);

  useEffect(() => {
    if (user?.id) {
      setUser({
        id: user.id,
        email: user.email,
        username: user.name || user.email,
      });
      applyReplaySampling(hasBackofficeAccess);

      // Also set GA4 user properties
      if (typeof window !== 'undefined' && window.gtag) {
        window.gtag('set', 'user_properties', {
          user_id: user.id,
          user_type: 'authenticated',
        });
      }
    } else {
      // Anonymous user
      setUser({
        id: undefined,
        username: 'anonymous',
      });
      applyReplaySampling(false);
    }
  }, [user?.id, user?.email, hasBackofficeAccess]);
}

